<template>
    <div @click="clickCampaign()">
        <div :class="{ campaign: darkBG }">
            <div class="img-contaier">
                <img
                    :src="campaign.fullImageUrl"
                    class="img-campaign"
                    :class="{ square: square }"
                />
            </div>
            <div class="box-card">
                <div class="title-campaign">{{ campaign.name }}</div>
                <div v-if="showPoint" class="detail-point">
                    ใช้ {{ campaign.pointPerUnit }} คะแนน
                    <img
                        class="ic_coffee"
                        src="../../../assets/icon/point_v.svg"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";

export default {
    name: "CampaignItem",
    props: {
        lbl: Object,
        index: Number,
        campaign: Object,
        square: Boolean,
        darkBG: Boolean,
        showPoint: Boolean,
        isClickCampaign: Boolean,
        isNews: Boolean,
    },
    data: function () {
        return {
            lblCampaign: this.lbl.campaign,
        };
    },
    created: function () {},
    mounted: function () {
        //this.lblCampaign = this.lbl.campaign;
    },
    methods: {
        //event
        clickCampaign: function () {
            //GA
            if (this.isClickCampaign) {
                var path = this.isNews
                    ? "/news/" + this.campaign.id
                    : "/campaign/" + this.campaign.id;
                this.$router.push(path);
            }
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1 ? true : false;
        },
        //utility
        getPointMessage: function () {
            var pointType =
                this.campaign.pointType == "get"
                    ? this.lblCampaign.get_point
                    : this.lblCampaign.use_point;
            var pointUnit =
                this.lblCampaign.point +
                (this.campaign.pointPerUnit > 1 &&
                Locale.getLocaleCode() == 1033
                    ? "s"
                    : "");
            return (
                pointType + " " + this.campaign.pointPerUnit + " " + pointUnit
            );
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./campaignlist.scss"; //get style from this sheet
@import "@/style/_mixin.scss";
.campaign {
    background-color: $color-light-grey-500;
}
.ic_coffee {
    width: auto;
    height: 15px !important;
}
</style>
